import { Component, OnInit } from '@angular/core';
import { BookingService } from '../../../../core/services/booking.service';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { RecaptchaService } from 'src/app/core/services/recaptcha.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';

declare let gtag: (property: string, value: any, configs: any) => {};

@Component({
  selector: 'app-booking-confirmed',
  templateUrl: './booking-confirmed.component.html',
  styleUrls: ['./booking-confirmed.component.scss']
})
export class BookingConfirmedComponent implements OnInit {
  closeResult: string;
  public date: string = '';
  public plant: string = '';
  public hour: string = '';
  public address: string = '';
  public reference: string = '';
  public codePlant: string = '';
  public codeType: string = '';
  public reservationCode: string = '';
  public check: boolean = false;
  public tarifa: string = '';
  public latitude: string = '';
  public longitude: string = '';
  public zoom: number = 13;
  public typeReser: string;
  public isRebooking: boolean = false;
  public myRecaptcha: boolean = false;
  public myProcesoRecaptcha: boolean = false;

  constructor(
    private bookingService: BookingService,
    private route: Router,
    private routePath: ActivatedRoute,
    private _recaptchaService: RecaptchaService,  
    private recaptchaV3Service: ReCaptchaV3Service
  ) { 
    routePath.queryParamMap.subscribe((query:any) => {
      if(query.params.rebook)
        this.isRebooking = true;
    });
  }

  ngOnInit() {
    this.getBookingData();
  }

  /* Gets the booking data (values) from bookingService memory */
  getBookingData() {
    this.bookingService.getBookingData().subscribe(
      (response) => {
        this.date = response.selected_date;
        if (this.date === undefined) {
          this.route.navigateByUrl('/');
        } else {
          this.date = this.convertStringToFomart(response.selected_date);
          this.hour = moment(response.selected_hour, ['H:mm']).format('h:mm A');
          this.plant = response.plant;
          this.address = response.address_plant;
          this.reference = response.reference;
          this.codePlant = response.code_plant;
          this.reservationCode = response.vehicle_patent;
          this.latitude = response.latitude;
          this.longitude = response.longitude;
          this.tarifa = response.tarifa;
          this.typeReser = response.type_reser;
        }
      }
    );
  }

  convertStringToFomart(dt, format = 'DD MMMM YYYY') {
    moment.locale('es-es');
    return moment.utc(dt).format(format);
  }

  home() {
    gtag('event', 'Reserva7', {'event_category': 'Reserva7', 'event_label': 'Reserva7', 'value': 'Reserva7'});
    let url = '/booking/ending-booking/true';
    if(this.isRebooking) url += '?rebook=true';
    this.route.navigateByUrl(url);
  }

  payment() {
    gtag('event', 'Reserva8', {'event_category': 'Reserva8', 'event_label': 'Reserva8', 'value': 'Reserva8'});
    this.route.navigateByUrl('/booking/payment');
  }

  getInfoRecaptcha(event: any) {
    const idButton = event.target.id;
    this.recaptchaV3Service.execute('importantAction')
      .subscribe((token) => {
        console.log(`Token [${token}] generated`)
          const auxiliar = this._recaptchaService.getTokenClientModule(token)
          auxiliar.subscribe( {
            complete: () => {

            },
            error: () => {
              this.myProcesoRecaptcha = true;
            },
            next: (resultado: Boolean) => {
              if (resultado === true) {
                if(idButton == "buttonPayment"){
                  this.payment();
                }else{
                  this.home();
                }                
                this.myRecaptcha = false;
              } else {
                this.myRecaptcha = true;
              }
            }
          });
        }
      );
  }
}
